// extracted by mini-css-extract-plugin
export default {"container":"Config_container__la20C","boxActivities":"Config_boxActivities__H3QHK","boxBtn":"Config_boxBtn__MYgko"};